import { Chip } from "@heroui/react";
import { useTranslation } from "react-i18next";


function IrrigateChip() {
    const { t } = useTranslation();
    return (
        <Chip
            classNames={{
                base: "bg-red-100 font-bold",
                content: "font-bold text-red-700",
            }}
            radius="sm"
            size="sm"
        >
            {t("irrigate", { ns: "fields-list" })}
        </Chip>
    );
}

export default IrrigateChip;